import { useState } from "react";
import { categories, posts } from "@/mocks/posts";
import PostCard from "@/components/feature/PostCard";
import SectionHeading from "@/components/feature/SectionHeading";

const tabs = [{ name: "全部", slug: "all" }, ...categories.map((c) => ({ name: c.name, slug: c.slug }))];

export default function NewsGrid() {
  const [active, setActive] = useState("all");

  const list =
    active === "all"
      ? posts.filter((p) => !p.featured).slice(0, 6)
      : posts.filter((p) => p.categorySlug === active);

  return (
    <section className="w-full bg-background-100 border-b border-background-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <SectionHeading
          eyebrow="新瓜汇总"
          title="今天又有哪些新瓜"
          desc="按主题分类整理，点开标签即可切换到对应内容，每个话题都标注了热度与讨论量。"
          moreTo="/breaking"
          moreLabel="进入爆料列表"
        />

        <div className="flex flex-wrap gap-2 mb-6">
          {tabs.map((tab) => {
            const isActive = active === tab.slug;
            return (
              <button
                key={tab.slug}
                type="button"
                onClick={() => setActive(tab.slug)}
                className={`px-4 py-1.5 rounded-full text-sm font-medium border transition-colors cursor-pointer whitespace-nowrap ${
                  isActive
                    ? "bg-foreground-950 text-background-50 border-foreground-950"
                    : "bg-background-50 text-foreground-700 border-background-300 hover:border-primary-400 hover:text-primary-700"
                }`}
              >
                {tab.name}
              </button>
            );
          })}
        </div>

        {list.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {list.map((post) => (
              <PostCard key={post.id} post={post} />
            ))}
          </div>
        ) : (
          <p className="text-sm text-foreground-500 py-10 text-center">该分类暂时没有更新，换个标签看看吧。</p>
        )}
      </div>
    </section>
  );
}